import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IViewConfig } from './models/view-config.model';

@Component({
  selector: 'app-tqw-view',
  templateUrl: './tqw-view.component.html',
  styleUrls: ['./tqw-view.component.scss']
})
export class TqwViewComponent {
  @ContentChild(TemplateRef) viewItem!: TemplateRef<unknown>;

  @Input() config!: IViewConfig;
}
